var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart, buildItemRow;
  init = function (options) {

  };
  loadCart = function () {
    console.log('added');
    $.getJSON('/cart.js', function(cart) {
      buildItemRow(cart);
    });
    // $('.cart-drawer').load(document.URL +  ' .cart-drawer-inner');
    // location.reload();
  };

  buildItemRow = function(cart_obj) {
		var cart_line_item = cart_obj['items'];
		console.log(cart_obj);
		$('.cart-drawer .total-cart').text(cart_obj.item_count);
		if(cart_obj.item_count > 1){
			$('.cart-drawer .item-title').text("Items");
		}else{
			$('.cart-drawer .item-title').text("Item");
		}
		
		$('.cart-toggle .cart-item-count').text(cart_obj.item_count);
		
		// Update subtotal
		var subtotalPrice = parseFloat(cart_obj.items_subtotal_price / 100);
		$('.checkout-box .subtotal-amount').text('$'+subtotalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
		
		// Calculate and update savings  
		var totalSavings = 0;
		cart_line_item.forEach(function(item) {
			// Use compare_at_price as original price
			if (item.compare_at_price && item.compare_at_price > item.price) {
				totalSavings += (item.compare_at_price - item.price) * item.quantity;
			}
		});
		
		if (totalSavings > 0) {
			$('.checkout-box .savings-amount').text('$'+parseFloat(totalSavings / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
			$('.checkout-box .cart-savings').show();
			
			// Update original price using subtotal + savings
			var originalPrice = subtotalPrice + parseFloat(totalSavings / 100);
			var originalPriceHtml = '<span class="undiscounte-price">$' + originalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + '</span>';
			if ($('.checkout-box .subtotal-price-wrapper .undiscounte-price').length) {
				$('.checkout-box .subtotal-price-wrapper .undiscounte-price').text('$' + originalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
			} else {
				$('.checkout-box .subtotal-amount').before(originalPriceHtml);
			}
		} else {
			$('.checkout-box .cart-savings').hide();
			$('.checkout-box .subtotal-price-wrapper .undiscounte-price').remove();
		}
		cart_line_item.forEach(function(item_obj) {
			var itemRow = $('.cart-drawer .cart-items .drawer-row-item[data-productid="'+item_obj.id+'"]');
			if (itemRow.length > 0) {
				itemRow.find('.quantity-wrapper input').val(item_obj.quantity);
				var itemPrice = parseFloat(item_obj.line_price / 100);
				itemRow.find('.item-total').text('$'+itemPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
			} else {
				var itemRowHtml = '';
				var itemPrice =  parseFloat(item_obj.line_price / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
				itemRowHtml += `<div class="drawer-row-item" data-productid="${item_obj.id}" data-price="${item_obj.price}">
													<div class="row">
														<div class="col-6">
															<span class="btn-remove-item">×</span>
																<div class="grid-item grid-thumb">
																		<div class="product-thumbnail">
																				<div class="product-image align-middle">
																						<a href="${item_obj.url}">
																							<canvas width="114" height="125" style="background-image: url(${item_obj.featured_image.url})" class="canvas-image heightbase"></canvas>
																						</a>
																				</div>
																		</div>
																</div>
														</div>
														<div class="col-6">
															<div class="grid-item grid-desc grid-x align-middle">
																	<div class="product-details">
																			<a href="${item_obj.url}">${item_obj.title}</a>
																			<div class="quantity-wrapper">
																					<span class="btn-quantity-control btn-reduce-quantity drawer-reduce">–</span>
																					<input type="number" name="updates[]" id="updates_${item_obj.key}" value="${item_obj.quantity}" min="0" aria-label="Item quantity" class="input-quantity"  data-qtylimit="5">
																					<span class="btn-quantity-control btn-add-quantity drawer-add">+</span>
																			</div>
																	</div>
															</div>
															<div class="grid-item grid-price-remove">
																	<div class="item-total">$${itemPrice}</div>
															</div>
														</div>
													</div>
												</div>`;
				$('.cart-drawer .cart-items').prepend(itemRowHtml);
			}
		});
		$('body').addClass('slide-cart');
	};

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));